/**
 * 校验是否是pc浏览器
 */
const isPc = () => {  
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");  
  var flag = true;  
  for (var v = 0; v < Agents.length; v++) {  
      if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }  
  }  
  return flag;  
}

const resize = (initWidth) => {
  let windowSize = {
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
    ratio: window.devicePixelRatio,
    scale: document.documentElement.clientWidth / initWidth
  }
  let str = `width=${initWidth}, initial-scale=${windowSize.scale}, maximum-scale=${windowSize.scale}, minimum-scale=${windowSize.scale}, user-scalable=no`
  document.getElementById('viewport') && document.getElementById('viewport').setAttribute('content', str)
}

const loadImage = (url) => {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.src = url
    image.onload = function() {
      resolve(image)
    }
    image.onerror = function(err) {
      reject(err)
    }
  })
}

const lazyloadImages = (domClass, delay = 50) => {
  document.querySelectorAll(domClass).forEach(item => {
    const { src } = item.dataset
    setTimeout(() =>{
      item.src = src
    }, delay)
  })
}

export default {
  isPc,
  resize,
  loadImage,
  lazyloadImages
}